import React, { useState } from "react";
import classNames from "classnames";
import { graphql, navigate, StaticQuery } from "gatsby";
import OutsideClickHandler from "react-outside-click-handler";
import SVG from "../../svg";

import * as styles from "./styles.module.scss";

const IntlMenu = () => {
  let [open, setOpen] = useState(false);
  let [locale] = useState(process.env.GATSBY_STRAPI_LOCALE);

  const handleLinkClick = (locale, url, e) => {
    // TODO - handle locale change with cookies?
    e.preventDefault();
    navigate(url);
  };

  return (
    <OutsideClickHandler onOutsideClick={() => setOpen(false)}>
      <StaticQuery
        query={graphql`
          query LocaleQuery {
            site {
              siteMetadata {
                locales {
                  id
                  link_text
                  link_text_abbr
                  url
                }
              }
            }
          }
        `}
        render={(data) => {
          const links = data.site.siteMetadata.locales;
          const currentLocale = links.find((item) => item.id.slice(0, 2) === locale);
          return (
            <div className={classNames(`intl_menu`, styles.intl_menu)}>
              <button
                className={classNames(`nav_link`, {
                  [styles.open]: open,
                  [styles.closed]: !open
                })}
                onClick={() => {
                  setOpen(!open);
                }}
              >
                <SVG name="globe" />
                <span>{currentLocale.link_text_abbr}</span>
                <SVG name="angle-down" />
              </button>

              <nav
                className={classNames({
                  [styles.open]: open,
                  [styles.closed]: !open
                })}
              >
                {links.map((item) =>
                  currentLocale.id === item.id ? null : (
                    <div key={item.id}>
                      <button onClick={(e) => handleLinkClick(item.link_text_abbr, item.url, e)}>
                        {item.link_text_abbr}
                      </button>
                    </div>
                  )
                )}
              </nav>
            </div>
          );
        }}
      />
    </OutsideClickHandler>
  );
};

export default IntlMenu;
